import { useMutation, useQuery } from '@tanstack/react-query';

import proficiencyLevelService, {
    type ProficiencyLevelReplacePayload,
} from './proficiencyLevelService';

import type { ProficiencyLevelDefinition } from '@/types/competency/ProficiencyLevelDefinition';

import { queryClient } from '@/AppWithProviders';
import { ProficiencyLevelQueryKey } from '@/constants/QueryKeys';

const invalidateProficiencyLevels = () => {
    queryClient.invalidateQueries({
        queryKey: [ProficiencyLevelQueryKey.PROFICIENCY_LEVELS],
    });
};

const useGetProficiencyLevels = (enabled = true) => {
    return useQuery<ProficiencyLevelDefinition[]>({
        queryKey: [ProficiencyLevelQueryKey.PROFICIENCY_LEVELS],
        queryFn: () => proficiencyLevelService.getProficiencyLevels(),
        enabled,
    });
};

const useReplaceProficiencyLevels = () => {
    return useMutation({
        mutationFn: (payload: ProficiencyLevelReplacePayload) =>
            proficiencyLevelService.replaceProficiencyLevels(payload),
        onSuccess: invalidateProficiencyLevels,
    });
};

export { useGetProficiencyLevels, useReplaceProficiencyLevels };
